<template>
  <div>
    <el-drawer
      ref="drawer"
      size="55%"
      :visible.sync="viewDrawer"
      :destroy-on-close="true"
      :before-close="beforeClose"
      @close="closeDrawer"
      :wrapperClosable="false"
    >
      <div class="el-drawer__content" v-loading="isLoading">
        <el-form ref="form" :model="formModel" :rules="rules">
          <el-row :gutter="15">
            <el-col :sm="12">
              <el-form-item label="Repair Station" prop="station_id">
                <el-select v-model="formModel.station_id" filterable clearable>
                  <el-option
                    v-for="loc in locations"
                    :key="loc.id"
                    :value="loc.id"
                    :label="loc.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="12">
              <el-form-item label="Date Received" prop="date_received">
                <el-date-picker
                  type="date"
                  v-model="formModel.date_received"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :sm="12">
              <el-form-item label="Customer" prop="customer">
                <el-select v-model="formModel.customer" clearable filterable>
                  <el-option
                    v-for="d in customers"
                    :value="d.value"
                    :key="d.value"
                    :label="d.text"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="12">
              <el-form-item label="Collected From" prop="collected_from">
                <el-input v-model="formModel.collected_from"></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="12">
              <el-form-item label="Collection Receipt No." prop="collected_receipt_no">
                <el-input
                  :disabled="isDisabled"
                  v-model="formModel.collected_receipt_no"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table :data="formModel.list">
            <el-table-column label="Actions" width="60">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  circle
                  icon="el-icon-delete"
                  @click="removeULD(scope.row)"
                >
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="ULD ID Code">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.masterlist_id"
                  filterable
                  clearable
                  remote
                  :remote-method="findMasterlist"
                  @change="addNewRow"
                >
                  <el-option
                    v-for="code in codes"
                    :key="code.id"
                    :value="code.id"
                    :label="code.uld_id_code"
                    :disabled="checkUsage(code)"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="JOB ORDER NO">
              <template slot-scope="scope">
                <span>{{ generateJO(scope) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Status">
              <template slot-scope="scope">
                <el-form-item label="Status" prop="status_id">
                  <el-select
                    v-model="scope.row.status_id"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="s in repairStatus"
                      :value="s.id"
                      :key="s.id"
                      :label="s.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="el-drawer__footer">
          <el-button
            size="small"
            type="primary"
            @click="batchSave"
            :disabled="isLoading"
            >Save</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="addULD"
            :disabled="isLoading"
            >Add ULD</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import ULD from "@/models/ULD";
import RepairLocation from "@/models/RepairLocation";
import Masterlist from "@/models/Masterlist";
import RepairStatus from "@/models/RepairStatus";
import moment from "moment";
export default {
  name: "addForm",

  data() {
    return {
      isLoading: false,
      viewDrawer: false,
      formModel: { list: [] },
      customers: [],
      locations: [],
      codes: [],
      selectedCodes: [],
      categories: ULD.categories(),
      latest: 0,
      rules: {
        date_received: [
          { required: true, message: "Date received is required." }
        ],
        station_id: [
          { required: true, message: "Repair Station is required." }
        ],
        customer: [{ required: true, message: "Customer is required." }],
        collected_from: [
          { required: true, message: "Collected From is required." }
        ],
        category: [{ required: true, message: "Category is required." }],
        // collected_receipt_no: [
        //   { required: true, message: "Collection Receipt is required." }
        // ]
      }
    };
  },
  computed: {
    isDisabled() {
      // Return true if selectedValue is not "Etihad"
      if(this.formModel.customer !== 6){
        return true;
      }
      else {
        return false;
      }
    }
  },
  methods: {
    open() {
      this.codes = [];
      Masterlist.searchUld({ q: "", limit: 15, exclude: 1 }).then(resp => {
        this.codes = resp;
      });

      this.viewDrawer = true;
      this.getLatestULD();
      this.formModel = { list: [], category: "uld_in" };
      this.addULD();
    },
    closeDrawer() {
      this.viewDrawer = false;
      // this.getLatestULD();
    },
    beforeClose(done) {
      if (this.isLoading) return false;
      return done();
    },
    batchSave() {
      this.$confirm("Do you want to create Job Order from this list?")
        .then(() => {
          this.$refs.form.validate(valid => {
            if (!valid) return false;
            if (
              this.formModel.list.length == 1 &&
              !this.formModel.list[0].masterlist_id
            ) {
              this.$notify({
                type: "error",
                message: "ULD ID Code information is required.",
                position: "bottom-right"
              });
              return false;
            }
            this.isLoading = true;
            let promises = [];
            let payload = [];
            for (let uld of this.formModel.list) {
              if (uld.masterlist_id) {
                // console.log("uld.status_id", uld.status_id)
                payload.push({
                  masterlist_id: uld.masterlist_id,
                  status_id: uld.status_id,
                  date_received: moment(this.formModel.date_received).format(
                    "YYYY-MM-DD"
                  ),
                  station_id: this.formModel.station_id,
                  // location_id: this.formModel.location_id,
                  customer: this.formModel.customer,
                  collected_from: this.formModel.collected_from,
                  collected_receipt_no: this.formModel.collected_receipt_no,
                  category: this.formModel.category
                });
              }
            }
            promises.push(ULD.store({ data: payload }));
            Promise.all(promises).then(() => {
              this.$store.dispatch("uld/fetchList", { limit: 25 });
              this.isLoading = false;
              this.closeDrawer();
              this.$notify({
                type: "success",
                message: "Job Order information saved.",
                position: "bottom-right"
              });
            });
          });
        })
        .catch(() => {});
    },
    generateJO(scope) {
      // let uld = scope.row;
      let idx = scope.$index;
      idx = parseInt(idx) + 1 + parseInt(this.latest);
      return process.env.VUE_APP_PREFIX+"-" + idx.toString().padStart(5, 0);
    },
    addULD() {
      this.formModel.list.push({
        masterlist_id: "",
        status_id: 8,
        _id: Date.now()
      });
    },
    addNewRow(value) {
      if (value) {
        let code = this.codes.find(o => o.id == value);
        if (code) {
          this.selectedCodes.push(code);
        }
      }

      let filled = this.formModel.list.find(o => o.masterlist_id == "");
      if (!filled) {
        this.addULD();
      }
    },
    removeULD(uld) {
      this.formModel.list = this.formModel.list.filter(o => o._id != uld._id);
    },
    getLatestULD() {
      ULD.latest().then(resp => {
        this.latest = resp.id;
      });
    },
    findMasterlist(queryString) {
      if (queryString.length >= 3) {
        Masterlist.searchUld({ q: queryString, limit: 15, exclude: 1 }).then(
          resp => {
            this.codes = resp;
            for (let code of this.selectedCodes) {
              let check = this.codes.find(o => o.id == code.id);
              if (!check) this.codes.push(code);
            }
          }
        );
      }
    },
    checkUsage(code) {
      let check = false;
      check = this.formModel.list.find(o => o.masterlist_id == code.id);
      if (check) return true;
      return check;
    }
  },
  created() {
    RepairLocation.list({ limit: 99999 }).then(list => {
      this.locations = list.data;
    });

    this.customers = [];
    ULD.customers_data().then(list => {
      this.customers = list;
    });
    RepairStatus.list({ limit: 99999 }).then(list => {
      this.repairStatus = list.data;
    });

    // Masterlist.list({ limit: 99999 }).then(list => {
    //   this.codes = list.data;
    // });
  }
};
</script>

<style lang="css" scoped></style>
